module.exports = __webpack_public_path__ + "static/media/raftofthemedusa20142.76c8485a.jpg";